import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { DirectSaleProgramGateway } from 'src/app/application/gateway/DirectSaleProgramGateway';
import { DirectSaleProgram } from 'src/app/domain/models/DirectSaleProgram';
import { BasicUser } from 'src/app/domain/models/User';

@Component({
  selector: 'app-edit-program-from-stock',
  templateUrl: './edit-program-from-stock.component.html',
  styleUrls: ['./edit-program-from-stock.component.css']
})
export class EditProgramFromStockComponent {


  formGroup: FormGroup = this._formBuilder.group({
    programId: [null, Validators.required],
    programName: [null],
  });

  loading: boolean = false;
  submit: boolean = false;
  programType: number = 0;
  profile: BasicUser | undefined
  programs: DirectSaleProgram[] = []

  constructor(
    private _formBuilder: FormBuilder,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _messageService: MessageService,
    private _authService: AuthGateway,
    private _directSaleProgramService: DirectSaleProgramGateway,
  ) { }

  ngOnInit(): void {
    this.profile = this._authService.getUser()
  }

  @Input()
  stockId!: number;

  // getPrograms(): void {
  //   this.loading = true;
  //   this._directSaleProgramService.get().subscribe({
  //     next: (response) => {
  //       this.programs = response.map(item => item).filter(program => program != null) as DirectSaleProgram[];
  //       this.loading = false;
  //     },
  //     error: (error) => {
  //       this._messageService.add({
  //         severity: 'error',
  //         summary: 'Error',
  //         detail: 'No se pudieron cargar los programas'
  //       });
  //       this.loading = false;
  //       console.error('Error al obtener programas:', error);
  //     }
  //   });
  // }

}
